var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,0A18,18,0,1,0,36,18,18,18,0,0,0,18,0Zm6.06,21.94a1.49,1.49,0,0,1,0,2.12,1.5,1.5,0,0,1-2.12,0L18,20.12l-3.94,3.94a1.5,1.5,0,0,1-2.12,0,1.49,1.49,0,0,1,0-2.12L15.88,18l-3.94-3.94a1.5,1.5,0,0,1,2.12-2.12L18,15.88l3.94-3.94a1.5,1.5,0,0,1,2.12,2.12L20.12,18Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXSolid);
export default __webpack_public_path__ + "static/media/xSolid.63ec2a5bd75cd98fb4a2eba76d56bc0e.svg";
export { ForwardRef as ReactComponent };